export default __webpack_public_path__ + "static/media/icon-publicacoes.b0cb64ff.svg";